import { render, staticRenderFns } from "./cookiesModal.vue?vue&type=template&id=67d93204"
import script from "./cookiesModal.vue?vue&type=script&lang=js"
export * from "./cookiesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports